const newTest = state => (state.newTest !== null ? state.newTest : {})

const getTestById = (state, getters) => (id) => {
  let result = state.tests && Object.keys(state.tests).length > 0 ? state.tests : []
  var data = result && id in result ? result[id] : false
  return data
}

const tests = (state) => {
  let result = state.tests && Object.keys(state.tests).length > 0 ? Object.values(state.tests) : []
  return result
}

const ongoingTests = (state, getters) => {
  let result = state.tests && Object.keys(state.tests).length > 0 ? Object.values(state.tests) : []
  const filtered = result.filter(t => t.isOngoing)
  return filtered
}

const finalisedTests = (state, getters) => {
  let result = state.tests && Object.keys(state.tests).length > 0 ? Object.values(state.tests) : []
  const filtered = result.filter(t => t.isFinalised)
  return filtered
}

const carriers = (state) => {
  let result = state.carriers && Object.keys(state.carriers).length > 0 ? Object.values(state.carriers) : []
  return result.sort(function (a, b) {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1
    }
    return 0
  })
}

const getCarrierById = (state, getters) => (id) => {
  let result = state.carriers && Object.keys(state.carriers).length > 0 ? state.carriers : []
  var data = result && id in result ? result[id] : false
  return data
}

const breakouts = (state) => {
  let result = state.breakouts && Object.keys(state.breakouts).length > 0 ? Object.values(state.breakouts) : []
  return result
}

export default {
  newTest,
  getTestById,
  tests,
  ongoingTests,
  finalisedTests,
  carriers,
  getCarrierById,
  breakouts
}



// WEBPACK FOOTER //
// ./src/store/modules/tests/getters.js